import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    Button
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    isOff: {
        justifyContent: 'center',
        padding: '0.5rem',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        }
    },
    isOn: {
        justifyContent: 'center',
        padding: '0.5rem',
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        }
    },
}))

const ToggleButton = ({ on, onText, offText, onIcon, offIcon, ...other }) => {
    const classes = useStyles()

    return <Button
        variant="outlined"
        className={on ? classes.isOn : classes.isOff}
        fullWidth
        startIcon={on ? onIcon : offIcon}
        {...other}
    >
        {on ? onText : offText}
    </Button >

}

export default ToggleButton